'use strict';

var cov_qkth7vu1i = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\title.js',
      hash = '367e96cc5c214d1897878cdc328c6acd086d3f46',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\title.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 6,
          column: 7
        }
      },
      '1': {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 5,
          column: 39
        }
      },
      '2': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 9,
          column: 6
        }
      },
      '3': {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 29
        }
      },
      '4': {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 17,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 3
          }
        },
        loc: {
          start: {
            line: 3,
            column: 62
          },
          end: {
            line: 10,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 4,
            column: 54
          },
          end: {
            line: 4,
            column: 55
          }
        },
        loc: {
          start: {
            line: 4,
            column: 64
          },
          end: {
            line: 6,
            column: 5
          }
        },
        line: 4
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 7,
            column: 19
          },
          end: {
            line: 7,
            column: 20
          }
        },
        loc: {
          start: {
            line: 7,
            column: 31
          },
          end: {
            line: 9,
            column: 5
          }
        },
        line: 7
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TitleController =
/** @ngInject */
function TitleController($scope, $window, $mdSidenav, $rootScope, $http) {
  _classCallCheck(this, TitleController);

  ++cov_qkth7vu1i.f[0];
  ++cov_qkth7vu1i.s[0];

  $http.get($rootScope.apiOpen + 'tracuu/now').then(function (result) {
    ++cov_qkth7vu1i.f[1];
    ++cov_qkth7vu1i.s[1];

    $scope.lichvannien = result.data;
  });
  ++cov_qkth7vu1i.s[2];
  $scope.totop = function () {
    ++cov_qkth7vu1i.f[2];
    ++cov_qkth7vu1i.s[3];

    $window.scrollTo(0, 0);
  };
};

++cov_qkth7vu1i.s[4];

angular.module('app').component('fountainTitle', {
  templateUrl: 'app/title.html',
  controller: TitleController
});